import { log } from './log';

export function suspendInstance()
{
    log('info', 'lifecycle::suspendInstance');
}
